import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import NavLink from '../NavLink';

const useStyles = makeStyles({
  menuItem: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    width: '100%',
    borderBottom: 'solid 1px #ececec',
    paddingTop: '16px',
    paddingBottom: '12px'
  },
  title: {
    marginLeft: 24,
    color: 'black',
    fontWeight: 'bold'
  },
  menuItemImg: {
    width: '56px',
    height: '56px'
  }
});

export function MenuItem({ imgSrc, title, link, hasAlert }) {
  const classes = useStyles();

  return (
    <div className={classes.menuItem}>
      <NavLink style={{ width: '100%', display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }} link={link}>
        {imgSrc && <img className={classes.menuItemImg} src={imgSrc} alt={title} />}
        <span className={classes.title}>{title}</span>
        {hasAlert && (
          <span
            style={{
              width: '12px',
              height: '12px',
              backgroundColor: '#ef4444',
              color: 'white',
              borderRadius: '50%',
              fontSize: '8px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginLeft: '8px',
              fontWeight: 'bold'
            }}
          >
            !
          </span>
        )}
      </NavLink>
    </div>
  );
}

export default MenuItem;
